import React from "react";
import { TierOptions } from "shared/AllDropDownOptions";
import { CustomAmountInput, CustomDropDown } from "shared/AllInputs";
import { CustomAmountViewInput, CustomViewInput } from "shared/AllViewInputs";
import { getTierName } from "./functions";

const AdministrativeCost = ({ type, data, handleChange }) => {
    return (
        <>
            {type === "View" ?
                <>
                    <div className="flex justify-content-between w-full title">
                        <CustomViewInput name="tier" value={getTierName(data?.tier)} className="lg:w-20rem" ignoreLabel />
                    </div>
                    <CustomAmountViewInput name="administrativeCost" data={data} col={4} />
                </>
                :
                <>
                    <div className="flex flex-wrap justify-content-between w-full">
                        <CustomDropDown
                            data={data}
                            name="tier"
                            options={TierOptions}
                            ignoreLabel
                            extraClassName="px-0 w-11rem"
                            col={3}
                            className=" w-full "
                            onChange={({ name, value }) => handleChange({ name: name, value: value, form: "administrative" })}
                        /></div>
                    <CustomAmountInput
                        data={data}
                        inputClass="m-0"
                        onChange={({ name, value }) => handleChange({ name: name, value: value, form: "administrative" })}
                        name="administrativeCost"
                        col={4}
                    />

                </>}
        </>
    );
};

export default AdministrativeCost;
